<h2>About My Location</h2>

<google-map
  height="250px"
  [center]="center"
  [zoom]="zoom"
  [options]="options">
</google-map>

<form class="usa-form">
  <fieldset class="usa-fieldset">
    <legend class="usa-legend">Location options</legend>
    <usa-radio-group [name]="'locOption'" [value]="locationOptions.mode" [(ngModel)]="locationOptions.mode">
      <usa-radio [value]="'auto'">Use auto-determined location</usa-radio>
      <usa-radio [value]="'address'">Use my address</usa-radio>
      <usa-radio [value]="'manual'">Manually set location</usa-radio>
    </usa-radio-group>
  </fieldset>
  
  <ng-container *ngIf="locationOptions.mode == 'auto'">
    <button class="usa-button usa-button--accent-warm" type="button" (click)="getLocation()">Show On Map</button>
  </ng-container>
  
  <ng-container *ngIf="locationOptions.mode == 'address'">
    <label class="usa-label" for="input-address">Address</label>
    <input class="usa-input" type="text" id="input-address" name="input-address" [(ngModel)]="address">
    
    <button class="usa-button usa-button--accent-warm" type="button" (click)="findAddress()">Show On Map</button>
  </ng-container>
  
  <ng-container *ngIf="locationOptions.mode == 'manual'">
    <p>To set your location directly on the map, click the "Add a marker" button in the top right corner of the map window. Your cursor will change to a crosshair and you can click the map to add a location. Otherwise, enter the latitude and longitude of your location below.</p>
    
    <label class="usa-label" for="input-latitude">Latitude</label>
    <input class="usa-input" type="number" id="input-latitude" name="input-latitude" [(ngModel)]="latitude">
    
    <label class="usa-label" for="input-longitude">Longitude</label>
    <input class="usa-input" type="number" id="input-longitude" name="input-longitude" [(ngModel)]="longitude">
    
    <button class="usa-button usa-button--accent-warm" type="button" (click)="showLocation()">Show On Map</button>
  </ng-container>
</form>

<p>
  <button class="usa-button" type="button" (click)="save()">Save</button>
  <button class="usa-button usa-button--secondary" type="button" routerLink="/" skipLocationChange>Cancel</button>
</p>
